import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { getRequest } from '../../helpers/apiHandler';
import { showAlert } from '../../store/actions/alertAction';

const WhatsAppNumberDropdown = ({ isLoggedIn }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const [phoneNumbers, setPhoneNumbers] = useState([]);

  useEffect(() => {
    if (isLoggedIn) {
      const requestData = { headers: { Authorization: access_token.token } };
      getRequest('/v2/whatsapp/get-shared-business', requestData, (res) => {
        if (res.success) {
          const wabaData = res.data.data;
          if (wabaData.length > 0) {
            const defaultWabaId = wabaData[0].target_ids[0];
            // Now let's fetch phone numbers
            getRequest(
              `/v2/whatsapp/get-phone-numbers?waba_id=${defaultWabaId}`,
              requestData,
              (res) => {
                if (res.success) {
                  const phoneNumbersResponse = res.data.data;
                  const formattedPhoneNumbers = phoneNumbersResponse.data.map((number) => ({
                    value: number.id,
                    label: `${number.verified_name} - ${number.display_phone_number}`,
                  }));
                  setPhoneNumbers(formattedPhoneNumbers);
                  dispatch(
                    showAlert(
                      'Integration Successful. Your WhatsApp Business Platform (API) has been successfully Integrated through Facebook',
                      'success'
                    )
                  );
                } else {
                  setPhoneNumbers([]);
                  dispatch(showAlert('Integration Failed. Please retry again', 'danger'));
                }
              }
            );
          }
        }
      });
    }
  }, [isLoggedIn]);

  return (
    <>
      <p>Choose the phone number to be connected.</p>
      <Select
        options={phoneNumbers}
        onChange={(selectedOption) => {
          console.log(selectedOption);
        }}
      />
    </>
  );
};

export default WhatsAppNumberDropdown;
